import { httpClientWithRaven } from '../../../clients/hubHttpWithRaven';
import { registerQuery } from 'data-fetching-client';
export const GET_PROCESSING_PAYMENT_METHOD_TYPES = registerQuery({
  fieldName: 'processingPaymentMethodTypes',
  fetcher() {
    return httpClientWithRaven.get('/transactions-experience/v1/payments/payment-method-types-with-status?paymentStatus=Processing');
  }
});